/**
 * AddDistributorCtrl controller
 * Add/Edit Distributors
 */

/**
 * AddDistributorCtrl controller
 *
 * @class AddDistributorCtrl
 * @memberof mwApp/partners
 * @see mwApp/partners
 *
 * @ngdoc controller
 * @name mwApp/partners.controller:AddDistributorCtrl
 */
/* @ngInject */
export default function AddDistributorCtrl ($scope, alertLiteSvc, Distributor, distributor) {
  var vm = this

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Distributor
   *
   * @memberof mwApp/partners.controller:AddDistributorCtrl
   * @type {models.Distributor}
   */
  vm.distributor = distributor

  /**
   * isNew flag
   *
   * @memberof mwApp/partners.controller:AddDistributorCtrl
   * @type {Boolean}
   */
  vm.isNew = distributor._isNew()

  vm.passVisible = false

  /**
   * Original distributor's password
   *
   * @memberof mwApp/partners.controller:AddDistributorCtrl
   * @type {String}
   */
  vm.originalPassword = distributor.password

  /**
   * Check, if distributor password was changed
   *
   * @memberof mwApp/partners.controller:AddDistributorCtrl
   * @type {Boolean}
   */
  vm.pw = function () {
    return vm.originalPassword !== distributor.password
  }

  /**
   * Networks
   *
   * @memberof mwApp/partners.controller:AddDistributorCtrl
   * @type {Network[]}
   */
  vm.networks = []

  if (vm.isNew) {
    // load networks from extra for distributor
    Distributor.loadExtra(Distributor.extraFor(distributor))
      .to(vm)
      .then(() => { $scope.loading = false })
  } else {
    // add single distributor's network to list
    vm.networks.push(distributor.network)
    $scope.loading = false
  }

  /**
   * Create or edit distributor
   *
   * @memberof mwApp/partners.controller:AddDistributorCtrl
   */
  vm.submit = function () {
    if (vm.isDisabled() || vm.patternError(vm.distributor.password) || vm.atLeastError(vm.distributor.password)) {
      return
    }
    vm.setDisable()
    distributor._save(undefined, undefined, undefined, undefined, true)
      .then(vm.location(distributor).reload)
      .catch((e) => {
        if (e?.data.includes('distributor_email')) {
          alertLiteSvc.alertError(`Not unique email "${distributor.email}"`)
        } else {
          alertLiteSvc.alertError(e.data)
        }
      })
      .finally(vm.unsetDisable)
  }

  /**
   * Delete distributor
   *
   * @memberof mwApp/partners.controller:AddDistributorCtrl
   */
  vm.delete = function () {
    vm.setDisable()
    distributor._delete()
      .then(vm.location(distributor).list)
      .finally(vm.unsetDisable)
  }

  /**
   * Validate password by pattern
   * @param test
   * @returns {boolean}
   */
  vm.patternError = function (test) {
    const regex = /^[a-zA-Z0-9@#$_&\-*!?. ]+$/
    return !regex.test(test)
  }

  /**
   * Show user's password
   *
   * @memberof mwApp/settings.controller:AddSubscriberCtrl
   */
  vm.viewPassword = function () {
    vm.passVisible = !vm.passVisible
  }

  /**
   * Validate password by contain symbols
   * @param test
   * @returns {boolean}
   */
  vm.atLeastError = function (test) {
    if (test) {
      return !/(?=.*[A-Z])(?=.*\d).*/.test(test)
    }
    return false
  }
}
